import { Area } from "../types";
import { ProductCategoryType, Region, RegionPricing } from "@hubcapp/types";
import { initialAreaPriceMap } from "../helpers";

export const filterPricesByProductCategory = (
  productCategoryType: ProductCategoryType,
  regionPricing?: Array<RegionPricing>,
): Array<RegionPricing> => {
  if (!regionPricing || regionPricing.length === 0) {
    return [];
  }

  return regionPricing.filter((price: RegionPricing) => {
    if (
      (productCategoryType === ProductCategoryType.PreTest ||
        productCategoryType === ProductCategoryType.PostTest) &&
      (price.productCategory?.type === ProductCategoryType.PreTest ||
        price.productCategory?.type === ProductCategoryType.PostTest)
    ) {
      return true;
    }

    if (
      productCategoryType === ProductCategoryType.DitCar &&
      price.productCategory?.type === ProductCategoryType.DitCar
    ) {
      return true;
    }

    if (
      productCategoryType === ProductCategoryType.Motability2015 &&
      price.productCategory?.type === ProductCategoryType.Motability2015
    ) {
      return true;
    }

    if (
      productCategoryType === ProductCategoryType.Motability2018 &&
      price.productCategory?.type === ProductCategoryType.Motability2018
    ) {
      return true;
    }

    return false;
  });
};

export const transformRegionToInitialArea = (
  region: Region,
  type: ProductCategoryType,
) => ({
  id: region.id,
  name: region.regionName,
  type,
  areaCode: region.regionCode,
  districts: mapDistricts(region.districts),
  discounts: [],
  numberOfDistricts: region.districts.length,
  numberOfCoveredDistricts: 0,
  pricing: filterPricesByProductCategory(
    type,
    region?.pricing as Array<RegionPricing>,
  ).map((regionPrice: RegionPricing) => ({
    ...initialAreaPriceMap(
      regionPrice,
      null,
      regionPrice.id,
      regionPrice.productCategory?.type as ProductCategoryType,
    ),
    value: "",
  })),
  instructorPricing: [],
  numberOfDiscountsAvailable: region.discounts?.length,
  numberOfDiscountsApplied: 0,
});

const mapDistricts = (districts: Region["districts"]) =>
  districts.map(district => ({
    id: district?.id || "",
    postcode: district?.districtCode || "",
    sectors:
      district?.sectors.map(sector => ({
        id: sector?.id || "",
        name: sector?.sectorCode || "",
      })) || [],
  }));

export const mapAreaStateToCreateAreaCoverageMutation = (
  area: Area,
  instructorId: string,
  propositionAllocationId: string,
) => {
  const preTestPrice = area.pricing?.find(
    pricing => pricing.name === "PreTest",
  );
  const postTestPrice = area.pricing?.find(
    pricing => pricing.name === "PostTest",
  );

  return {
    instructorId: instructorId,
    lineItemKey: propositionAllocationId,
    regionCodeKey: area?.id,
    discounts: area.discounts?.map(discount => ({
      discountId: discount?.id,
      optIn: true,
    })),
    districtOptIns:
      area.districts.map(district => ({
        id: district.id,
        sectorOptOuts:
          district.sectorsToOptOut?.map(sector => ({
            id: sector.id,
          })) || [],
      })) || [],
    preTestPrice: preTestPrice ? parseFloat(preTestPrice.value) : undefined,
    postTestPrice: postTestPrice ? parseFloat(postTestPrice.value) : undefined,
  };
};

export const getAreaPageTitle = (type: string | undefined) => {
  switch (type) {
    case ProductCategoryType.PreTest:
      return "learner";
    case ProductCategoryType.PostTest:
      return "learner";
    case ProductCategoryType.DitCar:
      return "DIT";
    case ProductCategoryType.DitClassroom:
      return "DIT";
    case ProductCategoryType.Motability2015:
      return "motability";
    case ProductCategoryType.Motability2018:
      return "motability";
  }
};
